const variables = {
  'border-radius': 16,
  'border-radius-button': 5,
  'border-radius-round': 999,
  gap: 24,
  'primary-button-disabled-opacity': 0.15,
  'primary-button-font-size': 14,
  'secondary-button-border-width': 2,
  'secondary-button-disabled-opacity': 0.5,
  'secondary-button-font-size': 14,
} as const;

export default variables;
